import { Button, SimpleGrid } from '@mantine/core';
import { useCreate } from '@pankod/refine-core';
import { FieldValues, useForm } from '@pankod/refine-react-hook-form';
import {
  EmailField,
  FirstNameField,
  GenderField,
  LastNameField,
  PhoneField,
  TitleField,
} from 'pages/users';
import { UsernameField } from './Fields';

export const CreateForm: React.FC = () => {
  const {
    handleSubmit,
    refineCore: { formLoading, onFinish },
    ...formProps
  } = useForm({
    refineCoreProps: {
      action: 'create',
      redirect: 'list',
    },
  });

  const userMutation = useCreate();

  const onSubmit = (values: FieldValues) => {
    const userValues = { ...values };
    // Delete username field when inserting in users table
    delete userValues.username;

    // Create the user
    userMutation.mutate(
      {
        resource: 'users',
        values: userValues,
      },
      {
        onSuccess(data) {
          // Create the account and populate the user ID
          onFinish({
            user_id: data?.data.id,
            username: values.username,
          });
        },
      }
    );
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <SimpleGrid spacing="md" sx={(theme) => ({ maxWidth: theme.breakpoints.xs })}>
        <TitleField formProps={formProps} />
        <FirstNameField formProps={formProps} />
        <LastNameField formProps={formProps} />
        <UsernameField formProps={formProps} />
        <EmailField formProps={formProps} />
        <PhoneField formProps={formProps} />
        <GenderField formProps={formProps} />
        <Button loading={userMutation.isLoading || formLoading} mt="xs" type="submit">
          Create
        </Button>
      </SimpleGrid>
    </form>
  );
};
